export default __webpack_public_path__ + "static/media/graminha.39460acd.svg";